import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ShieldCheck, Mail, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function PrivacyPolicy() {
  const lastUpdated = "15 Mei 2024";
  return <section id="privacy-policy" className="bg-background py-12 md:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {}
        <div className="mb-8">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Beranda</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Kebijakan Privasi</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <div className="mb-10 text-center md:text-left">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-lg mb-6">
            <ShieldCheck className="size-8 text-primary" />
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default tracking-tight mb-4">
            Kebijakan Privasi
          </h1>
          <div className="flex items-center justify-center md:justify-start gap-2 text-muted-foreground font-sans text-sm">
            <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
            <span>Terakhir diperbarui: {lastUpdated}</span>
          </div>
        </div>

        {}
        <div className="bg-card text-card-foreground rounded-xl shadow-sm border border-border p-6 md:p-10 lg:p-12">
          <div className="space-y-8 font-sans">
            {}
            <div>
              <p className="text-muted-foreground leading-relaxed text-base md:text-lg">
                Selamat datang di <strong>ABADI.NEWS</strong>. Kami sangat menghargai privasi Anda dan berkomitmen penuh untuk melindungi data pribadi Anda. Kebijakan Privasi ini menjelaskan secara rinci bagaimana kami mengumpulkan, menggunakan, memproses, dan menjaga informasi Anda saat Anda mengunjungi dan berinteraksi dengan situs web kami.
              </p>
            </div>

            <Separator />

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                1. Informasi yang Kami Kumpulkan
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Kami dapat mengumpulkan informasi dari Anda dalam berbagai cara saat Anda menggunakan situs kami, termasuk namun tidak terbatas pada:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                <li><strong>Informasi Identifikasi Pribadi:</strong> Nama, alamat email, nomor telepon, atau informasi kontak lainnya saat Anda mendaftar akun, berlangganan buletin, atau mengisi formulir kontak.</li>
                <li><strong>Data Non-Pribadi:</strong> Alamat IP, jenis peramban (browser), sistem operasi, penyedia layanan internet, dan data penggunaan situs yang dikumpulkan secara otomatis melalui teknologi pelacakan.</li>
              </ul>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                2. Bagaimana Kami Menggunakan Informasi Anda
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Informasi yang kami kumpulkan dapat digunakan untuk tujuan berikut:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                <li>Mempersonalisasi pengalaman pengguna dan menyajikan konten yang paling relevan dengan minat Anda.</li>
                <li>Meningkatkan kualitas situs web, layanan, dan penawaran kami berdasarkan umpan balik yang kami terima.</li>
                <li>Mengirimkan email berkala terkait berita terbaru, pembaruan, atau informasi layanan (Anda dapat berhenti berlangganan kapan saja).</li>
                <li>Menanggapi pertanyaan, permintaan layanan pelanggan, dan memberikan dukungan teknis.</li>
              </ul>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                3. Penggunaan Cookies dan Teknologi Pelacakan
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                ABADI.NEWS menggunakan "cookies" dan teknologi pelacakan serupa untuk melacak aktivitas di layanan kami dan menyimpan informasi tertentu. Cookies adalah file dengan sejumlah kecil data yang mungkin menyertakan pengidentifikasi unik anonim. Anda dapat menginstruksikan peramban Anda untuk menolak semua cookies atau untuk menunjukkan kapan cookie sedang dikirim. Namun, jika Anda tidak menerima cookies, Anda mungkin tidak dapat menggunakan beberapa bagian dari layanan kami secara optimal.
              </p>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                4. Keamanan Data
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Keamanan data Anda sangat penting bagi kami. Kami menerapkan berbagai langkah keamanan teknis dan organisasi yang wajar untuk melindungi informasi pribadi Anda dari akses, penggunaan, atau pengungkapan yang tidak sah. Meskipun demikian, perlu diingat bahwa tidak ada metode transmisi melalui internet atau metode penyimpanan elektronik yang 100% aman dan andal, sehingga kami tidak dapat menjamin keamanan mutlaknya.
              </p>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                5. Hak-hak Pengguna
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Sesuai dengan undang-undang privasi yang berlaku, Anda memiliki hak-hak tertentu terkait data pribadi Anda, termasuk:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                <li>Hak untuk mengakses dan meminta salinan data pribadi Anda yang kami simpan.</li>
                <li>Hak untuk meminta perbaikan data yang tidak akurat atau tidak lengkap.</li>
                <li>Hak untuk meminta penghapusan data pribadi Anda dalam kondisi tertentu.</li>
                <li>Hak untuk menarik persetujuan pemrosesan data kapan saja.</li>
              </ul>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                6. Kepatuhan Hukum
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Kami mematuhi hukum dan peraturan yang berlaku di Republik Indonesia terkait perlindungan data pribadi. Kami tidak menjual, memperdagangkan, atau menyewakan informasi identifikasi pribadi pengguna kepada pihak ketiga. Kami dapat membagikan informasi demografis agregat generik yang tidak tertaut ke informasi identifikasi pribadi apa pun dengan mitra bisnis, afiliasi tepercaya, dan pengiklan kami untuk tujuan yang diuraikan di atas.
              </p>
            </div>

            {}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-foreground font-default mb-4">
                7. Perubahan pada Kebijakan Privasi
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                ABADI.NEWS memiliki keleluasaan untuk memperbarui Kebijakan Privasi ini kapan saja. Saat kami melakukannya, kami akan merevisi tanggal pembaruan di bagian atas halaman ini. Kami mendorong pengguna untuk sering memeriksa halaman ini untuk mengetahui perubahan apa pun agar tetap mendapat informasi tentang bagaimana kami membantu melindungi informasi pribadi yang kami kumpulkan.
              </p>
            </div>

            <Separator />

            {}
            <div className="bg-muted/50 rounded-lg p-6 text-center md:text-left flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h3 className="text-lg font-semibold text-foreground font-default mb-2">
                  Punya Pertanyaan?
                </h3>
                <p className="text-muted-foreground text-sm">
                  Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, silakan hubungi tim dukungan kami.
                </p>
              </div>
              <Button asChild size="lg" className="shrink-0">
                <Link to="#">
                  <Mail className="mr-2 size-4" />
                  Hubungi Kami
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}